import React from 'react'
import { FaFacebook,  FaLinkedin, FaTwitter } from 'react-icons/fa'
import {FooterContainer, FooterWrap, FooterLinksContainer, FooterLinksWrapper, 
FooterLinkItems, FooterLinkTitle, FooterLink, SocialIconLink, SocialIcons,
SocialLogo, SocialMedia, WebsiteRights, SocialMediaWrap, FooterLinks} from "./FooterElement"

import {animateScroll as scroll} from "react-scroll";
import { Typography } from '@mui/material';

const Footer = () => {
    const toggleHome =()=>{
        scroll.scrollToTop()
    }

    return (
        <FooterContainer>
            <FooterWrap>
                <FooterLinksContainer>
                   
                    <Typography variant="h6">I'm Olawuni Olukunle a Full-Stack Developer, specialising in core Full Stack 
                        technologies such as React, MongoDB, Express, Node, JavaScript, Redux, Typescript 
                        and Material UI.</Typography>
                    <FooterLinksWrapper>
                        <FooterLinkItems>
                            <FooterLinkTitle>Quick Links</FooterLinkTitle>
                                <FooterLink to="about">Home</FooterLink>
                                <FooterLink to="skills">Skills</FooterLink>
                                <FooterLink to="services">Services</FooterLink>
                                <FooterLink to="portfolio">Portfolio</FooterLink>
                                <FooterLink to="contact">Contact Me</FooterLink>
                        
                        </FooterLinkItems>
                        
                    </FooterLinksWrapper>

                    <FooterLinksWrapper>
                        <FooterLinkItems>
                            <FooterLinkTitle>Social Media</FooterLinkTitle>
                       
                                <FooterLinks href="https://www.facebook.com/olukunle.olawuni" target="_blank">Facebook</FooterLinks>
                                <FooterLinks href="https://www.linkedin.com/in/olukunle-olawuni-2b6a9b130/" target="_blank">LinkedIn</FooterLinks>
                         
                                <FooterLinks href="https://www.twitter.com/OlawuniOlukunl3" target="_blank">Twitter</FooterLinks>
                        </FooterLinkItems>
                        </FooterLinksWrapper>
                        
                </FooterLinksContainer>
                <SocialMedia>
                    <SocialMediaWrap>
                        <SocialLogo to="/" onClick={toggleHome}>
                          Olawuni Olukunle
                        </SocialLogo>
                        
                        <SocialIcons>
                            <SocialIconLink href="https://www.facebook.com/olukunle.olawuni" target="_blank" aria-label="Facebook">
                                <FaFacebook/>
                            </SocialIconLink>
                            
                            <SocialIconLink href="https://www.twitter.com/OlawuniOlukunl3" target="_blank" aria-label="Twitter">
                                <FaTwitter/>
                            </SocialIconLink>
                            <SocialIconLink href="https://www.linkedin.com/in/olukunle-olawuni-2b6a9b130/" target="_blank" aria-label="LinkedIn">
                                <FaLinkedin/>
                            </SocialIconLink>
                        </SocialIcons>
                        <WebsiteRights>Olawuni Olukunle {new Date().getFullYear()} All rights reserved.</WebsiteRights>
                    </SocialMediaWrap>
                </SocialMedia>
            </FooterWrap>
        </FooterContainer>

    )}

export default Footer